import {
	Annotation,
	AnnotationPoint,
	AnnotationRectangle,
	MetadataBorderStyle,
	MetadataRectangle,
	PagePages,
	Parameter
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";

export class PortalAnnotation extends Annotation implements Parameter {
	public getBoundaries(page?: PagePages): MetadataRectangle {
		let result: MetadataRectangle | undefined;

		for (let position of FunctionHelper.applyValue(this.positions, Annotation.getPositionsDefault())) {
			let positionPoint: AnnotationPoint = position as AnnotationPoint;
			let positionRectangle: AnnotationRectangle = position as AnnotationRectangle;

			if (FunctionHelper.exists(positionPoint.point)) {
				if (!FunctionHelper.exists(result)) {
					result = MetadataRectangle.fromJson({
						width: FunctionHelper.applyValue(this.border?.width, MetadataBorderStyle.getWidthDefault()),
						height: FunctionHelper.applyValue(this.border?.width, MetadataBorderStyle.getWidthDefault()),
						x: positionPoint.point!.x,
						y: positionPoint.point!.y
					} as MetadataRectangle);
				}

				if (positionPoint.point!.x! < result!.x!) {
					result!.width! += result!.x! - positionPoint.point!.x!;
					result!.x = positionPoint.point!.x;
				}

				if (positionPoint.point!.y! < result!.y!) {
					result!.height! += result!.y! - positionPoint.point!.y!;
					result!.y = positionPoint.point!.y;
				}

				if (positionPoint.point!.x! - result!.x! > result!.width!) {
					result!.width = positionPoint.point!.x! - result!.x!;
				}

				if (positionPoint.point!.y! - result!.y! > result!.height!) {
					result!.height = positionPoint.point!.y! - result!.y!;
				}
			} else if (FunctionHelper.exists(positionRectangle.rectangle)) {
				if (!FunctionHelper.exists(result)) {
					result = MetadataRectangle.fromJson({
						width: positionRectangle.rectangle!.width,
						height: positionRectangle.rectangle!.height,
						x: positionRectangle.rectangle!.x,
						y: positionRectangle.rectangle!.y
					} as MetadataRectangle);
				}

				if (positionRectangle.rectangle!.x! < result!.x!) {
					result!.x = positionRectangle.rectangle!.x;
				}

				if (positionRectangle.rectangle!.y! < result!.y!) {
					result!.y = positionRectangle.rectangle!.y;
				}

				if (positionRectangle.rectangle!.width! > result!.width!) {
					result!.width = positionRectangle.rectangle!.width;
				}

				if (positionRectangle.rectangle!.height! > result!.height!) {
					result!.height = positionRectangle.rectangle!.height;
				}
			}
		}

		if (!FunctionHelper.exists(result)) {
			result = MetadataRectangle.fromJson({
				width: 0,
				height: 0,
				x: 0,
				y: 0
			} as MetadataRectangle)
		}

		if (FunctionHelper.exists(page)) {
			result!.x! -= FunctionHelper.applyValue(page!.boxes.cropBox?.x, MetadataRectangle.getXDefault());
			result!.y! -= FunctionHelper.applyValue(page!.boxes.cropBox?.y, MetadataRectangle.getYDefault());
		}

		return result!;
	}

	public static fromJson(data: any): PortalAnnotation {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAnnotation(data);
	}
}